module.exports = __webpack_public_path__ + "hyperion-v2-static/fonts/TruenoLtIt.49c656db.otf";